import React from 'react';
//import PropTypes from 'prop-types';
import {
  Label,
} from 'reactstrap';
import Services from '../services';
import _ from 'lodash';
import SelectField from '../../../components/Form/SelectField';

const FunkcioKedvezmenyForm = props => {
  const {
    modositas,
    formFunkcio,
    formKedvezmenyek,
    handleSelectInputChange,
  } = props;

  const loadFunkcioOptions = (input, callback) => {
    Services.listFunkcio(input, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( f => f.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadKedvezmenyOptions = (input, callback) => {
    Services.listKedvezmeny((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12" style={{paddingTop: '10px'}}>
            <SelectField
              variant='async'
              label='Funkció:'
              name="formFunkcio"
              id="formFunkcio"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formFunkcio')}
              loadOptions={_.debounce(loadFunkcioOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formFunkcio}
              cache={false}
              isLoading={false}
              isClearable
              defaultOptions
              required
            />
          </div>

          <div className="col-md-12" style={{paddingTop: '10px'}}>
            <SelectField
              label='Kedvezmények:'
              variant='async'
              name="formKedvezmenyek"
              id="formKedvezmenyek"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formKedvezmenyek')}
              loadOptions={_.debounce(loadKedvezmenyOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formKedvezmenyek}
              cache={false}
              isLoading={false}
              isClearable
              isMulti
              defaultOptions
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderForm()}
      </div>
    </div>
  );
}

export default FunkcioKedvezmenyForm;